
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiHydraulic14Static as ObiHydraulic14StaticElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-hydraulic-14-static.js';
 
 
 

 
 export const ObiHydraulic14Static = createComponent({
   react: React,
   tagName: 'obi-hydraulic-14-static',
   elementClass: ObiHydraulic14StaticElement,
   events: {
     
   }
  });
 
 